import { BetPlacementError } from '../bet-placement-error';
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { stringToNullableNumber } from '../error-convert-helpers';

export class BWIError extends BetPlacementError {
    constructor(bwiCode: string | undefined) {
        super();
        this.errorCode = stringToNullableNumber(bwiCode);
        this.icon = BetPlacementErrorIcon.Warning;
    }

    errorCode: number | null;
}
